export const scrollToTop = (element?: HTMLElement | null) => {
    // If element isn't passed in, use window
    const theElement = (element || window) as HTMLElement | Window
    theElement.scroll({ top: 0, left: 0, behavior: 'smooth' })
}
